import Vue from "vue";
import VueRouter from "vue-router";
import * as Logger from "js-logger";

import Home from "../layouts/home";
import Basket from "../layouts/Basket";
import NotFound from "../layouts/not-found";
import Devotee from "../layouts/devotee";
import Download from "../layouts/download";
import About from "../layouts/about";
import Contact from "../layouts/contact";
import Faq from "../layouts/faq";

Vue.use(VueRouter);

export default new VueRouter({
  routes: [
    {
      path: "/",
      name: " ",
      component: Home
    },
    {
      path: "/basket",
      name: "basket",
      component: Basket
    },
    {
      path: "/about",
      name: "about",
      component: About
    },
    {
      path: "/contact",
      name: "contact",
      component: Contact
    },
    {
      path: "/faq",
      name: "faq",
      component: Faq
    },
    {
      path: "/download/:uuid/:admin?",
      name: "download",
      props: true,
      component: Download
    },
    {
      path: "/devotee",
      name: "devotee",
      component: Devotee
    },
    {
      path: "*",
      component: NotFound
    }
  ],
  mode: "hash",
  linkActiveClass: "active"
});



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/router/index.ts